/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export class FieldSet {
  ID: string;
  NAME: string;
  DISPLAY_NAME?: string;
  FIELDS: FieldSetField[];

  static parse(json: any): FieldSet {
    if (json && typeof json === 'object') {
      const c = new FieldSet();

      c.ID = json.ID;
      c.NAME = json.NAME;
      c.DISPLAY_NAME = json.NAME;

      if (json.FIELDS)
        c.FIELDS = FieldSetField.parseArray(json.FIELDS);

      return c;
    } else return null;
  }

  static parseArray(json: any[]): FieldSet[] {
    const arr = [];

    if (json)
      for (const j of json)
        if (j)
          arr.push(FieldSet.parse(j));

    return arr;
  }
}

export class FieldSetField {
  ID: string;
  FIELD: string;
  DISPLAY_NAME: string;
  FIELDS: FieldSetField[];
  PARENT_ID: string;
  PARENT_FIELD?: any;
  TYPE: FieldSetType;

  // helpers
  isCollapsed = false;

  static parse(json: any): FieldSetField {
    if (json && typeof json === 'object') {
      const c = new FieldSetField();

      c.ID = json.ID;
      c.FIELD = json.FIELD;
      c.DISPLAY_NAME = json.DISPLAY_NAME;
      c.PARENT_ID = json.PARENT_ID;
      c.PARENT_FIELD = json.PARENT_FIELD;
      c.TYPE = FieldSetType[<string>json.TYPE];

      if (json.FIELDS)
        c.FIELDS = FieldSetField.parseArray(json.FIELDS);

      return c;
    } else return null;
  }

  static parseArray(json: any[]): FieldSetField[] {
    const arr = [];

    if (json)
      for (const j of json)
        if (j)
          arr.push(FieldSetField.parse(j));

    return arr;
  }
}

export enum FieldSetType {
  TEXT = 'TEXT',
  NUMBER = 'NUMBER',
  DATE = 'DATE',
  OBJECT  = 'OBJECT',
  ARRAY = 'ARRAY',
  ENUM = 'ENUM',
  BOOLEAN = 'BOOLEAN'
}

export enum FormulaType {
  CONCAT = 'CONCAT',
  CONTACT_AND = 'CONTACT_AND',
  SUM = 'SUM'
}
